module.exports = __webpack_public_path__ + "static/media/Building B-1-Meter_DB1C.ab47b75f.jpg";